import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { EsnContentType } from '../../../shared/types/atoms';
import { IconComponent } from '../icon/icon.component';

/**
 * The medium glyph in front of a content row's name. `external` adds the small link badge
 * for URL-sourced assets, so "Video" and "Video URL" read as the same kind of thing.
 */
@Component({
  selector: 'esn-content-type-icon',
  imports: [IconComponent],
  templateUrl: './content-type-icon.component.html',
  styleUrl: './content-type-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.role]': 'label() ? "img" : null',
    '[attr.aria-label]': 'label()',
    '[attr.aria-hidden]': 'label() ? null : "true"',
  },
})
export class ContentTypeIconComponent {
  readonly type = input.required<EsnContentType>();
  readonly external = input(false);

  /**
   * Accessible name (e.g. "Video URL"); without one the glyph is treated as decoration.
   */
  readonly label = input<string | null>(null);
}
